/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/social-export-api-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/social-export-api-client";
import type { GetUploadPlatformFeaturesQueryResponse, GetUploadPlatformFeaturesPathParams } from "../models/GetUploadPlatformFeatures";

export function getGetUploadPlatformFeaturesUrl(id: GetUploadPlatformFeaturesPathParams["id"]) {
  const res = { method: 'GET', url: `/upload/${id}/platform-features` as const }
  return res
}

/**
 * @summary Get available platform features for an upload
 * {@link /upload/:id/platform-features}
 */
export async function getUploadPlatformFeatures(id: GetUploadPlatformFeaturesPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<GetUploadPlatformFeaturesQueryResponse, ResponseErrorConfig<Error>, unknown>({ method : "GET", url : getGetUploadPlatformFeaturesUrl(id).url.toString(), ... requestConfig })
  return res.data
}